import { render, staticRenderFns } from "./Meeting.Layout.Lecturer.Column.vue?vue&type=template&id=7db80f5e&scoped=true&"
import script from "./Meeting.Layout.Lecturer.Column.vue?vue&type=script&lang=js&"
export * from "./Meeting.Layout.Lecturer.Column.vue?vue&type=script&lang=js&"
import style0 from "./Meeting.Layout.Lecturer.Column.vue?vue&type=style&index=0&id=7db80f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db80f5e",
  null
  
)

export default component.exports